module.exports = __webpack_public_path__ + "img/configurationButton.eb51d78d.png";